<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      :destroyOnClose="true"
      :width="800"
    >
      <a-spin :spinning="isLoading">
        <a-form-model
          ref="AccountHandlerForm"
          :model="accountHandler"
          :rules="rules"
          layout="vertical"
          autocomplete="off"
        >
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="Business" prop="businessId">
                <a-select
                  placeholder="Business"
                  v-model="accountHandler.businessId"
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="business in businesses"
                    :key="business.id"
                    :value="business.id"
                  >
                    {{ business.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="Initial" prop="initial">
                <a-input
                  autocomplete="off"
                  placeholder="Initial"
                  v-model="accountHandler.initial"
                />
              </a-form-model-item>
            </a-col>
          </a-row>

           <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="First Name" prop="firstname">
               <a-input
                  autocomplete="off"
                  placeholder="First Name"
                  v-model="accountHandler.firstname"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="Surname" prop="lastname">
                <a-input
                  autocomplete="off"
                  placeholder="Surname"
                  v-model="accountHandler.lastname"
                />
              </a-form-model-item>
            </a-col>
          </a-row>

            <a-row :gutter="16">
            <a-col :span="12">
            <a-form-model-item label="Country" prop="countryId">
            <a-select v-model="accountHandler.countryId" style="width: 100%"  placeholder="Country">
              <a-select-option
                v-for="country in countries"
                :key="country.id"
                :value="country.id"
              >
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="City" prop="city">
                <a-input
                  autocomplete="off"
                  placeholder="City"
                  v-model="accountHandler.city"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
      <template #footer>
        <a-button type="primary" @click="save" :loading="isSaving"
          >Save</a-button
        >
        <a-button @click="cancel">Cancel</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import ModalMixin from "../Common/Mixins/modalMixin";
import { accountHandlerMutations,lookupMutations,businessMutations,businessState,lookupState } from "../../Store/store";
export default {
  props: {
    accountHandler: {
      type: Object,
      default: () => ({}),
    },
   
  },

  mixins: [ModalMixin],
  data() {
    return {
      businessState,
      lookupState,
      rules: {
        initial: [
          {
            required: true,
            message: "Please input a initial!",
            trigger: "blur",
          },
        ],
        firstname: [
          {
            required: true,
            message: "Please input a First Name!",
            trigger: "blur",
          },
        ],
        lastname: [
          {
            required: true,
            message: "Please input a Surname!",
            trigger: "blur",
          },
        ],
        businessId: [
          { required: true, message: "Business is required!", trigger: "blur" },
        ],
         countryId: [
          { required: true, message: "country is required!", trigger: "blur" },
        ],
      },
      isSaving: false,
      isLoading: false,
      businesses: [],
      countries: [],
    };
  },
 async mounted(){
  if(businessState.businesses)
  {
    await businessMutations.setBusinesses();
  }

  if(lookupState.countries)
  {
    await lookupMutations.setCountries();
  }
   this.businesses= businessState.businesses;
    this.countries=  lookupState.countries;
  },

  computed: {
    addAccountHandlerSuccess() {
      return `Account Handler ${
        this.mode == this.modes.edit ? "updated" : "added"
      } successfully!`;
    },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    save() {
      this.$refs.AccountHandlerForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;
          try {
            if (this.mode == this.modes.edit) {
              await accountHandlerMutations.updateAccountHandler(
                this.accountHandler
              );
            } else {
              await accountHandlerMutations.addAccountHandler(
                this.accountHandler
              );
            }
            this.$message.success(this.addAccountHandlerSuccess);
            this.visible = false;
          } catch (error) {
            this.showError(error);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
    cancel() {
      this.tempAppSettingValue = this.getDefaultPassword;
      this.visible = false;
    },
  },
};
</script>